import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Search } from 'semantic-ui-react';
import { Analytics } from '../../Modules';
import onClickOutside from 'react-onclickoutside';
import PhoneUtils from '../../../lib/utils/phone';

const SearchComponent = class SearchComponent extends React.Component {
  static propTypes = {
    closeHandler: PropTypes.func,
    viewer: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    handleResultSelect: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      value: '',
      results: [],
      lastRequest: new Date(),
      cachedQuery: ''
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.viewer !== this.props.viewer) {
      this.parseResults(nextProps.viewer.user_contact_search.edges);
    }
  }

  componentWillUnmount() {
    if (document && document.activeElement) {
      document.activeElement.blur();
    }
  }

  parseResults(results) {
    const flattenedResults = results.map((result, index) => ({
      id: result.node.id,
      name: `${result.node.first_name} ${result.node.last_name
        ? result.node.last_name
        : ''}`,
      email:
        result.node.user_contact_emails.edges.length > 0
          ? result.node.user_contact_emails.edges[0].node.address
          : '',
      phone:
        result.node.user_contact_phones.edges.length > 0
          ? result.node.user_contact_phones.edges[0].node.number
          : '',
      childKey: index
    }));
    this.setState({ results: flattenedResults });
  }

  handleSearchChange(e, data) {
    this.setState({ value: data.value });
    if (data.value && data.value.length > 0) {
      this.setState({ cachedQuery: data.value, isLoading: true });
      this.trackAnalytics();
      this.props.relay.refetch({ query: data.value }, null, () =>
        this.setState({ isLoading: false })
      );
    }
  }

  handleClickOutside() {
    if (this.props.closeHandler) this.props.closeHandler();
  }

  handleResultSelect(e, data) {
    this.props.handleResultSelect(data);
    this.setState({ value: '' });
  }

  trackAnalytics() {
    if (new Date() - this.state.lastRequest > 5000) {
      this.setState({ lastRequest: new Date() }, () =>
        setTimeout(
          () =>
            Analytics.trackEvent('searched-contact', {
              query: this.state.cachedQuery
            }),
          5000
        )
      );
    }
  }

  render() {
    const { isLoading, value } = this.state;

    const resultRenderer = ({ name, email, phone }) =>
      <div style={{ position: 'relative' }}>
        <div>
          <div className='title'>
            {name}
          </div>
          <div className='description'>
            {PhoneUtils.formatPhoneNumber(phone)}
          </div>
          <div className='description'>
            {email}
          </div>
        </div>
      </div>;

    const rest = _.omit(
      this.props,
      'viewer',
      'results',
      'relay',
      'disableOnClickOutside',
      'enableOnClickOutside',
      'closeHandler',
      'outsideClickIgnoreClass',
      'router'
    );

    return (
      <Search
        loading={isLoading}
        onSearchChange={this.handleSearchChange}
        onResultSelect={this.handleResultSelect}
        results={this.state.results}
        value={value}
        onFocus={e => this.handleSearchChange(e, e.target.value)}
        resultRenderer={resultRenderer}
        placeholder='Search existing contacts...'
        fluid
        className='transparent globalHeaderSearch'
        {...rest}
      />
    );
  }
};

export default onClickOutside(SearchComponent);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ContactSearch.js